import React, { useState } from "react";
import './Footer.css';
import "isomorphic-fetch";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";


function Footer() {
  const { instance, accounts } = useMsal();

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  async function getAccessToken() {
    const result = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });

    return result.accessToken;
  }

  async function addGuestEmail(email) {
    if (!email) {
      alert("Please enter an email.");
      return;
    }
  
    try {
      //const res = await fetch("http://localhost:5001/api/add-to-sendgrid", {
      const res = await fetch("https://the-heritage-house.com/api/add-to-sendgrid", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
  
      // Handle non-200 responses
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || "Unknown error");
      }
  
      const data = await res.json();
  
      if (data.success) {
        alert("Added successfully!");
        setEmail("")
      } else {
        alert("Failed: " + (data.error || "Unknown error"));
      }
    } catch (err) {
      alert("Error: " + err.message);
    }
  }
  

  return (
    <footer className="page-wrapper">
      <div className="footer-div">
        <div className="footer-title-div">
          <h3 className="heritage-house-title-footer">THE HERITAGE HOUSE</h3>
          <p className="book-table-title-the-footer">Harvard, Illinois</p>

          <div className="footer-div-underline"></div>

          <form>
            <br /><br />

            <label className="join-mailing-list-label" htmlFor="email">
              JOIN OUR MAILING LIST:
            </label><br />

            <input 
              type="email"
              id="email"
              placeholder="you@example.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            /><br />

            <button 
              className="button" 
              id="submit-button"
              type="button" 
              onClick={() => addGuestEmail(email)}
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
